// import React, {useEffect, useState} from 'react';
import Icon from '@bonprix/pattern-library/templates/icon';
import {Typography} from '@bonprix/design-system';

export default function OrderHint({hint}) {
    return (
        <div className="product__order-hint__full_width">
            <Icon name="advice" className="product__order-hint-icon" />
            <Typography variant="body1" component="span">
                {hint}
            </Typography>
        </div>
    );
}
